module.exports = __webpack_public_path__ + "img/1F921.f8bf6c11.svg";